import axios from "axios";
const state = {
    notes:[],
    meta:{}
};
const getters = {};

const actions = {
    getNotes( {commit}, params = {} ){
        return axios
        .get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/notes", { params })
        .then(response => {
            commit('setNotes', response.data);
            return response.data;
        });
    }
};

const mutations = {
    setNotes(state, data){
        state.notes = data.data || [];
        state.meta = data.meta || {};
    }
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
